export default function joinPath(...segments) {
	return segments.join('/').replace(/\/+/g, '/');
}


